import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import { createComponent } from '../../services/components';
import { derivePropsFromObject } from '../../services/props';
export function createChildComponent(componentConfig, item, items) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    itemIndex = _ref.itemIndex;
  var children = componentConfig.children,
    propMap = componentConfig.propMap,
    component = componentConfig.component;
  var props = _objectSpread({
    children: _isNil(children) ? null : (children || []).map(function (child) {
      return createChildComponent(child, item, items, {
        itemIndex: itemIndex
      });
    })
  }, derivePropsFromObject(item, propMap, items, {
    itemIndex: itemIndex
  }));
  return createComponent(component, props);
}
export function multipleComponentIterator(_ref2) {
  var _ref2$iterator = _ref2.iterator,
    iterator = _ref2$iterator === void 0 ? [] : _ref2$iterator,
    _ref2$components = _ref2.components,
    components = _ref2$components === void 0 ? [] : _ref2$components,
    _ref2$limit = _ref2.limit,
    limit = _ref2$limit === void 0 ? null : _ref2$limit,
    _ref2$start = _ref2.start,
    start = _ref2$start === void 0 ? null : _ref2$start;
  if (_isEmpty(iterator)) {
    return null;
  }
  var finalIterator = iterator;
  if (!_isArray(iterator) && _isObject(iterator)) {
    finalIterator = [iterator];
  }
  if (start) {
    finalIterator = iterator.slice(start);
  }
  if (limit) {
    finalIterator = iterator.slice(0, limit);
  }
  var iteratedComponents = finalIterator.map(function (item, itemIndex) {
    return components.map(function (componentConfig) {
      return createChildComponent(componentConfig, item, iterator, {
        itemIndex: itemIndex
      });
    });
  });
  return iteratedComponents.reduce(function (acc, nextComponents) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(nextComponents));
  });
}